import './journey.css';
import cafeImg from '../../assets/cafe.png';
import opencafe from '../../assets/opencafe.png';

function ArrowLeftIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M19 12H5M11 6l-6 6 6 6" stroke="#3d2f7a" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function SparkleIcon({ className, color = '#ff9f2e' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none">
      <path d="M12 2c0 5.2-2.8 8-8 8 5.2 0 8 2.8 8 8 0-5.2 2.8-8 8-8-5.2 0-8-2.8-8-8Z" fill={color} />
    </svg>
  );
}

function PartyPopperIcon() {
  return (
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
      <path d="M3 21 9.5 8l6.5 6.5L3 21Z" fill="#ffb238" stroke="#ff9f2e" strokeWidth="1.2" strokeLinejoin="round" />
      <circle cx="16" cy="4" r="1.4" fill="#6c4ce8" />
      <circle cx="20" cy="9" r="1.1" fill="#17b8a6" />
      <circle cx="13" cy="3" r="1" fill="#ff3d81" />
      <path d="M18 12l2 1M19 6l2-1M14 2l1 2" stroke="#6c4ce8" strokeWidth="1.4" strokeLinecap="round" />
    </svg>
  );
}

function CheckIcon() {
  return (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
      <path d="M5 13l5 5L19 7" stroke="#ffffff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function GiftIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <rect x="4" y="10" width="16" height="10" rx="1.5" stroke="#ffffff" strokeWidth="1.8" />
      <rect x="4" y="7" width="16" height="4" rx="1.2" stroke="#ffffff" strokeWidth="1.8" />
      <path d="M12 7v13M12 7c-1.6-3-6-3-6 0s4.4 0 6 0Zm0 0c1.6-3 6-3 6 0s-4.4 0-6 0Z" stroke="#ffffff" strokeWidth="1.6" strokeLinejoin="round" />
    </svg>
  );
}

const CAFE_NAMES = ['Cafe Mocha', 'Brew House', 'Bean & Co.', 'The Daily Grind', 'Skyline Cafe'];

function buildCafes(total) {
  return Array.from({ length: total }, (_, i) => ({
    n: i + 1,
    name: CAFE_NAMES[i] || `Cafe ${i + 1}`,
  }));
}

export default function Journey({ onBack, onViewReward, collectedStars = 1, totalStars = 3 }) {
  const progressPct = Math.round((collectedStars / totalStars) * 100);
  const cafes = buildCafes(totalStars);
  const allCafesCompleted = collectedStars >= totalStars;

  return (
    <div className="journey-screen">
      <div className="journey-frame">
        <div className="journey-top">
          <button type="button" className="journey-back-btn" aria-label="Go back" onClick={onBack}>
            <ArrowLeftIcon />
          </button>
          <h1 className="journey-title">
            My Journey
          </h1>
          <span className="journey-top-spacer" />
        </div>

        <div className="journey-progress-card">
          <div className="journey-progress-header">
            <span className="journey-progress-label">Mission Progress</span>
          </div>
          <div className="journey-progress-count">
            {collectedStars}/{totalStars} <span className="journey-progress-count-label">Completed</span>
          </div>
          <div className="journey-progress-track">
            <div className="journey-progress-fill" style={{ width: `${progressPct}%` }} />
          </div>
        </div>

        <h2 className="journey-section-title">Cafes Discovered</h2>

        <div className="journey-cafe-grid">
          {cafes.map((cafe) => {
            const collected = cafe.n <= collectedStars;
            return (
              <div className={'journey-cafe-card' + (collected ? '' : ' journey-cafe-card-locked')} key={cafe.n}>
                <div className="journey-cafe-image-wrap">
                  <span className="journey-cafe-badge">{cafe.n}</span>
                  <img src={cafeImg} alt={cafe.name} className="journey-cafe-image" />
                </div>
                <span className="journey-cafe-name">{cafe.name}</span>
                <span className="journey-cafe-check">{collected && <CheckIcon />}</span>
              </div>
            );
          })}
        </div>

        {allCafesCompleted && (
          <button type="button" className="journey-reward-btn" onClick={onViewReward}>
            View My Reward
            <span className="journey-reward-icon">
              <GiftIcon />
            </span>
          </button>
        )}

        {/* TEST ONLY: jump straight to the reward screen without completing all cafes. */}
        <button type="button" className="journey-test-btn" onClick={onViewReward}>
          Test: View Reward
        </button>
      </div>
    </div>
  );
}
